import {DialogHeader, DialogHeading} from '@/components/ui/dialog-atoms/DialogAtoms'
import styled, {css} from 'styled-components'

export const StyledProjectDetailsDialogHeader = styled(DialogHeader)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 4.5}px ${spacing * 6}px;
    `
)

export const StyledProjectDetailsDialogHeading = styled(DialogHeading)(
    ({theme: {typography}}) => css`
        ${typography.textLg};
    `
)
